import { ColumnDef } from '@tanstack/react-table'
import { PlayerDataItem } from '@/modules/manage-player/type'
import { Button } from '@/common/ui/button'
import { SortingArrows } from '@/common/components/SortingArrows'
import { Link } from 'react-router-dom'
import { PlayerTagsCell } from '@/common/components/PlayerTagsCell'
import { PhoneCell } from '@/common/components/PhoneCell'
import { UsernameCell } from '@/common/components/UsernameCell'
import AssignPlayerTagsModal from '@/modules/manage-player/components/GetPlayerList/components/GetPlayerListTable/CellAction/components/AssignPlayerTagsModal'
import type { PlayerTagResponse } from '@/modules/tags/types'

export const columns: ColumnDef<PlayerDataItem>[] = [
	{
		accessorKey: 'username',
		header: 'ข้อมูลผู้เล่น',
		cell: ({ row }) => {
			const { id, username, phone, tags } = row.original
			return (
				<div className="space-y-1">
					<div className="block">
						<UsernameCell username={username} />
					</div>
					<div className="block">
						<PhoneCell playerId={id} phone={phone} />
					</div>
					<div className="block">
						<PlayerTagsCell tags={tags || []} />
					</div>
					<AssignPlayerTagsModal
						playerId={id}
						playerPhone={phone}
						currentTags={tags as unknown as PlayerTagResponse[]}
					/>
				</div>
			)
		},
	},
	{
		accessorKey: 'totalDepositAmount',
		header: ({ column }) => {
			return (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
					className="px-0 hover:bg-transparent"
				>
					ยอดฝากทั้งหมด
					<SortingArrows sortOrder={column.getIsSorted()} />
				</Button>
			)
		},
		cell: ({ row }) => {
			const deposit = row.original.totalDepositAmount
			const withdraw = row.original.totalWithdrawAmount
			const profit = row.original.totalProfit
			return (
				<div className="space-y-1">
					<p className="text-green-600">ฝาก: {deposit.toFixed(2)}</p>
					<p className="text-red-600">ถอน: {withdraw.toFixed(2)}</p>
					<p className={profit < 0 ? 'text-red-600' : 'text-green-600'}>
						กำไร: {profit.toFixed(2)}
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'totalWinloss',
		header: ({ column }) => {
			return (
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
					className="px-0 hover:bg-transparent"
				>
					W/L
					<SortingArrows sortOrder={column.getIsSorted()} />
				</Button>
			)
		},
		cell: ({ row }) => {
			const amount = row.original.totalWinloss
			return (
				<div className="space-y-1">
					<p className={amount < 0 ? 'text-red-600' : 'text-green-600'}>
						W/L: {amount.toFixed(2)}
					</p>
					<p className="text-xs text-muted-foreground">
						ออนไลน์ล่าสุด:{' '}
						{row.original.lastOnline
							? new Date(row.original.lastOnline).toLocaleDateString('th-TH', {
									year: 'numeric',
									month: '2-digit',
									day: '2-digit',
								})
							: '-'}
					</p>
				</div>
			)
		},
	},
	{
		id: 'details',
		header: 'การดำเนินการ',
		cell: ({ row }) => (
			<Button asChild variant="outline">
				<Link to={`/operator/get-player-list/player-detail/${row.original.id}`}>
					ดูข้อมูลผู้เล่น
				</Link>
			</Button>
		),
	},
]
